<template>
  <div class="manage-microsite-page">
    <el-container>
      <el-header class="header-container" height="52px">
        <div ref="headerBackBtn" class="header-back-btn" @click="handleBackBtnClick">
          <!-- <i class="el-icon-back btn-icon"></i>
          <span class="btn-label">{{ $t('microSite.editor.header.back') }}</span> -->
        </div>
        <div class="header-container">
          <div class="header-title">
            <span>{{ $t('microSite.editor.header.currentPage') }}</span>
            <span>{{ currentPageTitle }}</span>
          </div>
          <div v-if="isLocalType" class="previewer-size">
            <el-form inline>
              <el-form-item :label="$t('microSite.editor.header.width')">
                <el-input v-model="previewer.style.width"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="isLocalType" class="config-edit">
            <el-button @click="handleConfitEditorOpen">{{ $t('microSite.editor.header.editData') }}</el-button>
          </div>
          <div class="style-toggle">
            <el-button @click="handlePreviewToggle">{{ isPreview ? $t('microSite.editor.header.toEdit') : $t('microSite.editor.header.toPriview') }}</el-button>
          </div>
          <div class="style-toggle">
            <el-button @click="handleLanguageToggle">{{ language }}</el-button>
          </div>
          <div class="header-save-btn">
            <el-button @click="handleSave">{{ $t('microSite.editor.header.save') }}</el-button>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside class="tool-bar-container" width="250px">
          <div class="tool-bar">
            <iframe ref="toolBarSizeWatcher" class="tool-bar-size-watcher"></iframe>
            <el-menu
              class="tool-item-container"
              background-color="#FFF"
              text-color="#62b3e3">
              <el-submenu index="component">
                <span slot="title" class="submenu-title">{{ $t('microSite.editor.model.addModel') }}</span>
                <el-menu-item>
                  <div class="component-tool-container">
                    <template v-for="(item, index) in toolbarItems">
                      <div
                        v-if="item.isShow"
                        :key="index"
                        :span="10"
                        class="component-tool-item"
                        :class="[moduleNeedDisabled(item) && 'disabled-tool-item']"
                        @click="openCreateModuleEditor(item)">
                        <div class="component-tool-item-icon">
                          <div :class="item.icon"></div>
                        </div>
                        <div v-auto-tooltip="item.label" class="component-tool-item-label">
                          <span>{{ item.label }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="page">
                <div slot="title" class="page-menu">
                  <span class="submenu-title">{{ $t('microSite.editor.page.setUpPage') }}</span>
                  <i class="el-icon-circle-plus" @click.stop="openPageEditor()"></i>
                </div>
                <div
                  v-for="(item, index) in sitePages"
                  :key="index"
                  class="page-item">
                  <el-menu-item class="page-item-container" :title="item.status.onboarding && $t('microSite.editor.page.onboardingPage')" @click.native="togglePage(index)">
                    <div class="page-icon">
                      <i :class="item.isIndex ? 'el-icon-s-home' : 'el-icon-document'"></i>
                    </div>
                    <div class="page-name">{{ item.metaInfo.title }}</div>
                    <div v-if="!item.status.hiddenConfigPageBtn" class="page-edit" @click.stop="">
                      <el-dropdown trigger="click">
                        <i class="el-icon-s-tools"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="item.status.edit" @click.native="openPageEditor(item)">{{ $t('microSite.editor.page.edit') }}</el-dropdown-item>
                          <el-dropdown-item v-if="!item.isIndex" @click.native="handleShowPage(item)">{{ item.status.show ? $t('microSite.editor.page.hide') : $t('microSite.editor.page.show') }}</el-dropdown-item>
                          <el-dropdown-item v-if="item.status.delete" @click.native="handleDeletePage(item, index)">{{ $t('microSite.editor.page.delete') }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div v-if="!item.status.hiddenSelectPageBtn" class="page-select">
                      <i class="el-icon-d-arrow-right" @click.stop="switchRenderPage(item)"></i>
                    </div>
                  </el-menu-item>
                  <div class="page-divider"></div>
                  <el-collapse-transition>
                    <div class="page-project-items-div" v-show="!item.isFold">
                      <draggable
                        v-model="item.renderData.children"
                        group="projectItems"
                        :animation="200"
                        @end="onDragEnd"
                      >
                        <transition-group type="transition" name="flip-list">
                          <div v-for="(projectItem, itemIndex) in item.renderData.children" :key="'projectItem' + itemIndex" v-show="isAvailable(projectItem)">
                            <div class="project-item-div">
                              <span v-auto-tooltip class="project-title" @click="togglePage(index, itemIndex)"><i class="el-icon-sort"></i>{{ getProjectItemTitle(projectItem) }}</span>
                              <span class="hide-project-icon" @click="toggleProjectItem(index, itemIndex)">
                                <i :class="projectItem.skipMatch ? 'el-icon-minus' : 'el-icon-view'"></i>
                              </span>
                              <span class="edit-project-icon" @click="openModuleEditor(projectItem.tag, projectItem, true)"><i class="el-icon-edit"></i></span>
                              <span v-show="projectItem.children && projectItem.children.length > 0" class="arrow-down-project-icon">
                                <i :class="projectItem.isFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                              </span>
                            </div>
                            <el-collapse-transition>
                              <div class="page-project-items-div" v-show="!projectItem.isFold">
                                <draggable
                                  v-model="projectItem.children"
                                  group="subassemblyItems"
                                  :animation="200"
                                  @end="onDragEnd"
                                >
                                  <transition-group type="transition" name="flip-list">
                                    <div v-for="(subassembly, subassemblyIndex) in projectItem.children" :key="'projectItem' + itemIndex + subassemblyIndex" v-show="isAvailable(subassembly)">
                                      <div class="project-item-div subassembly">
                                        <span v-auto-tooltip class="project-title"><i class="el-icon-sort"></i>{{ getProjectItemTitle(subassembly) }}</span>
                                      </div>
                                    </div>
                                  </transition-group>
                                </draggable>
                              </div>
                            </el-collapse-transition>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </el-collapse-transition>
                </div>
              </el-submenu>
              <el-submenu index="theme">
                <span slot="title" class="submenu-title">{{ $t('microSite.editor.theme.setUptheme') }}</span>
                <el-menu-item>
                  <div class="theme-tool-container">
                    <div class="theme-tool-item bg-color-picker">
                      <div class="theme-tool-item-label">
                        <span class="submenu-title">{{ $t('microSite.editor.theme.bgColor') }}</span>
                      </div>
                      <el-color-picker ref="bgColorPicker" class="theme-tool-item-color-picker" popper-class="theme-tool-item-color-picker-popper" v-model="theme.bgColor"></el-color-picker>
                      <div class="theme-tool-item-color-text" @click="onBgColorTextClick">
                        <span>{{ theme.bgColor }}</span>
                      </div>
                    </div>
                    <div class="theme-tool-item btn-color-picker">
                      <div class="theme-tool-item-label">
                        <span class="submenu-title">{{ $t('microSite.editor.theme.btnColor') }}</span>
                      </div>
                      <el-color-picker ref="btnColorPicker" class="theme-tool-item-color-picker" popper-class="theme-tool-item-color-picker-popper" v-model="theme.btnColor"></el-color-picker>
                      <div class="theme-tool-item-color-text" @click="onBtnColorTextClick">
                        <span>{{ theme.btnColor }}</span>
                      </div>
                    </div>
                  </div>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="promotionLink">
                <span slot="title" class="submenu-title">{{ $t('microSite.editor.promotionLink.menu') }}</span>
                <el-menu-item
                  v-for="(item, index) in promotionLinkList"
                  class="promotion-link-item"
                  :key="index"
                  @click="onPromotionLinkClick(item)"
                >{{ $t(item.labelI18nKey) }}</el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </el-aside>
        <el-main class="page-previewer-container">
          <div class="page-size-container" style="display: none">
            <el-select class="usual-size-selector" :value="selectedSize">
              <el-option label="2" value="1"></el-option>
            </el-select>
            <div class="current-size"></div>
          </div>
          <div class="page-previewer" id="pagePreviewer">
            <!-- <el-scrollbar> -->
            <div class="page-previewer-out-box">
              <div class="page-previewer-inner-box site-render site-common site-previewer" :style="previewer.style" :class="previewer.class">
                <PageRender
                  v-if="currentPageRenderData"
                  isEditMode
                  :renderData="currentPageRenderData"
                  @openEditor="openModuleEditor"
                  @openChildEditor="openModuleChildEditor"
                  @changeChildrenOrder="changeChildrenOrder"/>
                <Chatbot
                  v-if="showChatbot && enableChatbot"
                  :btnDialogToggleBootem="'24px'"
                  :generateUserId="userId"
                  :showChatbotMessageBox="showChatbotMessageBox"
                  :company="company"/>
              </div>
            </div>
            <!-- </el-scrollbar> -->
          </div>
        </el-main>
      </el-container>
    </el-container>
    <DialogWrapper
      class="module-editor"
      :close-on-click-modal="false"
      :show.sync="moduleEditor.isOpen"
      :title="moduleEditor.title"
      @closed="onModuleEditorClosed"
    >
      <div>
        <component
          v-bind="moduleEditor.props"
          ref="editor"
          :is="moduleEditor.tag"
          :rootRenderData="currentPageRenderData"
        ></component>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="delete-btn"
            v-if="moduleEditor.props.isEditMode && moduleEditor.tag !== navigationName"
            @click="onModuleEditorDelBtnClick">{{ $t('microSite.editor.common.delete') }}
          </el-button>
          <el-button @click="moduleEditor.isOpen = false">{{ $t('microSite.editor.common.cancel') }}</el-button>
          <el-button type="primary" @click="onModuleEditorConfirmBtnClick">{{ $t('microSite.editor.common.confirm') }}</el-button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper
      :close-on-click-modal="false"
      :show.sync="pageEditor.isOpen"
      :title="pageEditor.title"
      @closed="onPageEditorClosed"
    >
      <el-form :model="pageEditor.formData" label-width="90px" label-position="left">
        <!-- <el-form-item :label="$t('microSite.editor.page.name')" prop="name">
          <el-input v-model="pageEditor.formData.name"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('microSite.editor.page.title')" prop="metaInfo.title">
          <el-input v-model="pageEditor.formData.metaInfo.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('microSite.editor.page.path')" prop="path">
          <el-input v-model="pageEditor.formData.path"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="isIndex">
          <el-checkbox v-model="pageEditor.formData.isIndex">{{ $t('microSite.editor.page.toIndex') }}</el-checkbox>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button v-if="pageEditor.isEditMode && !pageEditor.pageData.isIndex" class="delete-btn" @click="onPageEditorDelBtnClick">{{ $t('microSite.editor.common.delete') }}</el-button>
          <el-button @click="pageEditor.isOpen = false">{{ $t('microSite.editor.common.cancel') }}</el-button>
          <el-button type="primary" @click="onPageEditorConfirmBtnClick">{{ $t('microSite.editor.common.confirm') }}</el-button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper
      :show.sync="configEditor.isOpen"
      :close-on-click-modal="false"
    >
      <div class="code-editor" ref="codeEditor">
        <el-input type="textarea" v-model="configEditor.configCode"></el-input>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="configEditor.isOpen = false">{{ $t('microSite.editor.common.cancel') }}</el-button>
          <el-button type="primary" @click="onConfigEditorOkBtnclick">{{ $t('microSite.editor.common.confirm') }}</el-button>
        </div>
      </template>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import PageRender from './core/components/render/pageRender.vue'
import draggable from 'vuedraggable'
import {
  allToolbarItems,
  allEditors,
  getEditorTitle,
  createRenderData,
  createChildRenderData,
  isModuleAvailable,
  getProjectItemTitle,
  createRootCssStyle
} from './core/modules'

import RenderData from './core/RenderData'
import PageData from './core/PageData'
import navigation from './core/modules/navigation'
import Chatbot from '@/components/job/chatbot/index.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { MICRO_SITE_TYPE, MICRO_SITE_DEVICE_TYPE } from '@/constant/common'

const promotionLinkType = {
  company: 'company',
  mobileJobList: 'mobileJobList',
  addInTalentPool: 'addInTalentPool'
}

export default {
  components: {
    ...allEditors,
    draggable,
    PageRender,
    Chatbot,
    DialogWrapper
  },
  metaInfo () {
    return {
      title: this.currentPageTitle,
      style: this.cssStyleList,
      link: this.metaInfoLinkList
    }
  },
  data () {
    return {
      toolbarItems: allToolbarItems,
      selectedSize: null,
      previewer: {
        style: {
          width: null,
          minHeight: null
          // backgroundColor: '#FFFFFF'
        },
        class: {
          'site-mobile': false,
          'site-pc': true,
          'edit-mode': true
        }
      },
      theme: {
        bgColor: '#FFFFFF',
        btnColor: '#409EFF'
      },
      toolBarResizeTimeout: null,
      moduleEditor: {
        isOpen: false,
        tag: null,
        title: null,
        props: {
          isEditMode: false,
          renderData: null,
          childRenderData: null
        }
      },
      pageEditor: {
        isOpen: false,
        title: null,
        isEditMode: false,
        formData: { metaInfo: {}, status: {} },
        pageData: { metaInfo: {}, status: {}, isFold: false }
      },
      renderDataId: 0,
      configEditor: {
        editor: null,
        isOpen: false,
        configCode: ''
      },
      savedSitePages: [],
      savedTheme: {},
      cssStyleList: [],
      promotionLinkList: [
        { labelI18nKey: 'microSite.editor.promotionLink.company', linkType: promotionLinkType.company },
        { labelI18nKey: 'microSite.editor.promotionLink.mobileJobList', linkType: promotionLinkType.mobileJobList },
        { labelI18nKey: 'microSite.editor.promotionLink.addInTalentPool', linkType: promotionLinkType.addInTalentPool }
      ],
      companyInfo: {},
      metaInfoLinkList: [],
      showChatbot: false,
      enableChatbot: false,
      showChatbotMessageBox: false,
      userId: '',
      company: {
        id: null,
        root_company: null
      }
    }
  },
  computed: {
    ...mapGetters('microSite', [
      'isEditMode',
      'isPreview',
      'currentPage',
      'currentPageRenderData',
      'pagePathPrefix',
      'sitePages',
      'themes'
    ]),
    siteId () {
      return this.$route.params.siteId
    },
    siteEditorType () {
      return this.$route.params.type
    },
    siteLanguageType () {
      return this.$route.params.language
    },
    siteDeviceType () {
      return this.$route.params.device
    },
    pagePath () {
      return this.$route.params.pagePath
    },
    isMobileType () {
      return this.siteDeviceType === MICRO_SITE_DEVICE_TYPE.mobile
    },
    isLocalType () {
      return this.siteEditorType === MICRO_SITE_TYPE.local
    },
    isOnboardingType () {
      return this.siteEditorType === MICRO_SITE_TYPE.onboarding
    },
    isCrmType () {
      return this.siteEditorType === MICRO_SITE_TYPE.crm
    },
    isSatisfactionSurvey () {
      return this.siteEditorType === MICRO_SITE_TYPE.satisfaction_survey
    },
    isPostApplicant () {
      return this.siteEditorType === MICRO_SITE_TYPE.post_applicant
    },
    currentPageTitle () {
      return this.currentPage && this.currentPage.metaInfo && this.currentPage.metaInfo.title
    },
    language () {
      return this.$i18n.locale === 'en' ? this.$t('microSite.editor.header.chinese') : this.$t('microSite.editor.header.english')
    },
    navigationName () {
      return navigation.name
    },
    navigationRenderData () {
      return _.find(this.currentPageRenderData.children, { tag: this.navigationName })
    },
    navigationMenus: {
      get () {
        return this.navigationRenderData.data.props.menus
      },
      set (menus) {
        this.navigationRenderData.data.props.menus = menus
      }
    }
  },
  beforeCreate () {
  },
  created () {
    this.initSitePages()
  },
  mounted () {
    window.onbeforeunload = (e) => {
      const savedSitePages = this.getPagesWithoutFold(this.savedSitePages.map((page) => {
        return page.toObject()
      })).sort((page1, page2) => {
        return page1.id < page2.id ? -1 : 1
      })
      const newSitePages = this.getPagesWithoutFold(this.sitePages.map((page) => {
        return page.toObject()
      })).sort((page1, page2) => {
        return page1.id < page2.id ? -1 : 1
      })
      const savedSiteData = {
        theme: this.savedTheme,
        pages: this.getPagesWithoutFold(savedSitePages)
      }
      const newSiteData = {
        theme: this.theme,
        pages: this.getPagesWithoutFold(newSitePages)
      }
      if (JSON.stringify(savedSiteData) === JSON.stringify(newSiteData)) {
        window.onbeforeunload = null
      } else {
        return ''
      }
    }
    const toolBarSizeWatcher = this.$refs.toolBarSizeWatcher
    toolBarSizeWatcher.contentWindow.onresize = this.onToolBarResize
    if (this.isMobileType) {
      this.previewer.style.width = '375px'
      this.previewer.style.minHeight = (document.body.clientHeight - 52) + 'px'
      this.previewer.class['site-mobile'] = true
      this.previewer.class['site-pc'] = false
    } else {
      const previewerContainer = document.querySelector('#pagePreviewer.page-previewer')
      previewerContainer.style.display = 'block'
      this.previewer.style.minHeight = (document.body.clientHeight - 52) + 'px'
      this.previewer.class['site-mobile'] = false
      this.previewer.class['site-pc'] = true
      window.onresize = () => {
        this.previewer.style.minHeight = (document.body.clientHeight - 52) + 'px'
      }
    }
  },
  methods: {
    ...mapActions('microSite', [
      'updateSiteData',
      'getSiteDataById',
      'resetRuntimeData',
      'setPagePathPrefix',
      'setEditMode',
      'setPreview',
      'setMobile',
      'setLanguageCode',
      'setSitePages',
      'setCurrentPage',
      'setThemes']),
    ...mapActions('common', ['changeLanguage']),
    async initSitePages () {
      this.resetRuntimeData()
      this.setEditMode(true)
      this.setMobile(this.isMobileType)
      this.setLanguageCode(this.siteLanguageType)
      this.setPagePathPrefix(`/microsite-admin/${this.siteId}/${this.siteDeviceType}/${this.siteLanguageType}${this.siteEditorType && '/' + this.siteEditorType}`)
      if (this.isMobileType) {
        this.toolbarItems = this.toolbarItems.filter(item => item.tag !== 'PhotoWall')
      }
      if (!this.isCrmType) {
        this.toolbarItems = this.toolbarItems.filter(item => item.tag !== 'Form')
      }
      const resp = await this.getSiteDataById({ id: this.siteId, type: this.siteEditorType })
      if (resp) {
        this.companyInfo = resp.originResponse.company
        this.setCompanyLogo(resp)
        const pageData = this.formatResp(resp)
        const pages = pageData && pageData.pages
        let theme = pageData && pageData.theme
        let sitePages = null
        this.enableChatbot = resp.originResponse.enable_chatbot
        this.showChatbot = this.companyInfo.show_chatbot
        this.company = {
          id: this.companyInfo.id,
          root_company: {
            id: this.companyInfo.root_id
          }
        }
        if (pages && pages.length > 0 && theme) {
          sitePages = []
          _.forEach(pages, pageObj => {
            const pageData = PageData.parseObject(pageObj)
            pageData.isFold = true
            if (_.isArray(pageData.renderData.children)) {
              _.forEach(pageData.renderData.children, pageObjitem => {
                pageObjitem.isFold = true
              })
            }
            sitePages.push(pageData)
          })
        } else {
          sitePages = PageData.createDefaultPages(this.siteLanguageType)
          sitePages[0].isFold = true
          if (this.siteLanguageType === 'en') {
            const firstPage = sitePages[0]
            firstPage.name = 'Homepage'
            firstPage.metaInfo.title = 'Homepage'
            const firstPageNav = _.find(firstPage.renderData.children, { tag: this.navigationName })
            firstPageNav.data.props.menus[0].label = 'Homepage'
          }
          theme = this.theme
        }
        this.theme = theme
        const indexPage = _.find(sitePages, 'isIndex')
        const indexPageNav = _.find(indexPage.renderData.children, { tag: this.navigationName })
        if (indexPageNav) {
          _.forEach(sitePages, page => {
            const children = page.renderData.children
            _.forEach(children, (child, index) => {
              if (child.tag === this.navigationName) {
                child.data.props.menus = indexPageNav.data.props.menus
              }
            })
          })
        }
        let baseUrl = process.env.VUE_APP_STYLE_BASE_URL
        if (baseUrl.endsWith('/')) {
          baseUrl = baseUrl.substring(0, baseUrl.length - 1)
        }
        const linkList = []
        if (this.showChatbot) {
          linkList.push({
            rel: 'stylesheet',
            href: `${baseUrl}/static/style/henkel-bot.css`
          })
        }
        this.metaInfoLinkList = linkList
        this.sortProjectItems(sitePages)
        this.setSitePages(sitePages)
        this.setCurrentPage(indexPage)
        this.changeRoutePath()
        this.savedSitePages = _.cloneDeep(sitePages)
        this.savedTheme = _.cloneDeep(this.theme)
        this.setJobListIsShow()
      }
    },
    setJobListIsShow () {
      // onboarding without JobList component
      if (this.isOnboardingType) {
        this.toolbarItems.map(item => {
          if (item.tag === 'JobList') {
            item.isShow = false
          }
        })
      }
    },
    setCompanyLogo (resp) {
      // only onboarding show logo
      if (!this.isOnboardingType) {
        return
      }
      const logo = {
        show: true,
        path: resp.originResponse.company_logo
      }
      this.$eventBus.$on('getMicroSiteNavigationLogo', callback => {
        callback(logo)
      })
      this.$eventBus.$on('microSiteNavigationLogoClick', () => {
        const homePageData = _.find(this.sitePages, 'isIndex')
        this.switchRenderPage(homePageData)
      })
    },
    formatResp (resp) {
      const deviceType = this.$route.params.device === 'mobile' ? 'mobile' : 'pc'
      const languageCode = this.$route.params.language === 'en' ? 'en' : 'cn'
      return resp[deviceType][languageCode]
    },
    sortProjectItems (sitePages) {
      if (!sitePages) {
        sitePages = this.sitePages
      }
      _.forEach(sitePages, (page) => {
        page.renderData.children = _.sortBy(page.renderData.children, 'index')
        _.forEach(page.renderData.children, (child) => {
          if (child.children) {
            child.children = _.sortBy(child.children, 'index')
          }
        })
      })
    },
    onDragEnd () {
      this.$nextTick(() => {
        this.resetProjectItemIndex()
      })
    },
    resetProjectItemIndex () {
      _.forEach(this.sitePages, page => {
        for (let i = 0; i < page.renderData.children.length; i++) {
          page.renderData.children[i].index = i
          if (page.renderData.children[i].children) {
            for (let j = 0; j < page.renderData.children[i].children.length; j++) {
              page.renderData.children[i].children[j].index = j
            }
          }
        }
      })
    },
    getProjectItemTitle (projectItem) {
      let title = projectItem.data.props.title
      if (projectItem.tag === this.navigationName) {
        title = getProjectItemTitle(projectItem)
      } else if (!title) {
        title = getProjectItemTitle(projectItem)
      }
      return title
    },
    isAvailable (targetRenderData) {
      return isModuleAvailable(targetRenderData)
    },
    onToolBarResize () {
      const toolBarSizeWatcher = this.$refs.toolBarSizeWatcher
      const toolBarContainer = toolBarSizeWatcher.parentElement.parentElement
      if (toolBarContainer.scrollHeight > toolBarContainer.clientHeight) {
        toolBarContainer.style.width = '267px'
      } else {
        toolBarContainer.style.width = '250px'
      }
    },
    onDisplayBtnClick (pageComponentItem) {
      pageComponentItem.display = !pageComponentItem.display
    },
    onBgColorTextClick () {
      this.$refs.bgColorPicker.showPicker = true
    },
    onBtnColorTextClick () {
      this.$refs.btnColorPicker.showPicker = true
    },
    openPageEditor (pageData) {
      let isEditMode = true
      if (!pageData) {
        isEditMode = false
        const renderData = RenderData.createDefaultRootRenderData(this.currentPageRenderData)
        const status = {
          edit: true,
          delete: true,
          show: true
        }
        pageData = new PageData('', '', renderData, -1, false, {}, status)
        pageData.path = `/page/${pageData.id}`
        pageData.isFold = false
      }
      const formData = {}
      formData.name = pageData.name
      formData.path = pageData.path
      formData.isIndex = pageData.isIndex
      formData.metaInfo = _.cloneDeep(pageData.metaInfo)

      this.pageEditor.title = (isEditMode ? this.$t('microSite.editor.page.edit') : this.$t('microSite.editor.page.add')) + this.$t('microSite.editor.page.page')
      this.pageEditor.isEditMode = isEditMode
      this.pageEditor.pageData = pageData
      this.pageEditor.formData = formData
      this.pageEditor.isOpen = true
    },
    onPageEditorClosed () {
      this.pageEditor.title = null
      this.pageEditor.isEditMode = false
      this.pageEditor.pageData = { metaInfo: {}, status: {}, isFold: false }
      this.pageEditor.formData = { metaInfo: {}, status: {} }
    },
    onPageEditorConfirmBtnClick () {
      const pageData = this.pageEditor.pageData
      const formData = this.pageEditor.formData
      const titleHasChanged = formData.metaInfo.title !== pageData.metaInfo.title
      const pathHasChanged = formData.path !== pageData.path
      const oldPath = pageData.path
      pageData.name = formData.name
      pageData.path = formData.path
      pageData.isIndex = formData.isIndex
      pageData.metaInfo = _.cloneDeep(formData.metaInfo)
      pageData.status.delete = !formData.isIndex
      if (this.pageEditor.isEditMode) {
        if (pathHasChanged || titleHasChanged) {
          _.forEach(this.navigationMenus, menu => {
            if (!menu.isInner) {
              return
            }
            const path = menu.path
            const isPagePath = path.includes('?') ? path.startsWith(`${oldPath}?`) : path === oldPath
            if (!isPagePath) {
              return
            }
            if (pathHasChanged) {
              menu.path = path.replace(oldPath, pageData.path)
            }
            if (titleHasChanged) {
              menu.label = pageData.metaInfo.title
            }
          })
        }
      } else {
        this.navigationMenus.push({
          label: pageData.metaInfo.title,
          path: pageData.path,
          isInner: true,
          openInNewWindow: false
        })
        this.sitePages.push(pageData)
        this.switchRenderPage(pageData)
        this.$nextTick(() => {
          this.$eventBus.$emit('setSelectMenuItem', this.navigationMenus.length - 1)
        })
      }
      this.pageEditor.isOpen = false
    },
    onPageEditorDelBtnClick () {
      const index = _.findIndex(this.sitePages, this.pageEditor.pageData)
      this.handleDeletePage(this.pageEditor.pageData, index)
      this.pageEditor.isOpen = false
    },
    handleDeletePage (pageData, index) {
      this.sitePages.splice(index, 1)
      this.navigationMenus = _.filter(this.navigationMenus, item => !item.path.startsWith(pageData.path))
      const indexPage = _.find(this.sitePages, 'isIndex')
      this.setCurrentPage(indexPage)
      this.changeRoutePath()
    },
    handleShowPage (pageData) {
      pageData.status.show = !pageData.status.show
      if (!pageData.status.show) {
        this.navigationMenus = _.filter(this.navigationMenus, item => !item.path.startsWith(pageData.path))
        const indexPage = _.find(this.sitePages, 'isIndex')
        const targetPath = `${this.pagePathPrefix}${indexPage.path}`
        this.$router.push(targetPath)
        this.$nextTick(() => {
          this.$eventBus.$emit('setSelectMenuItem', _.findIndex(this.navigationMenus, { path: indexPage.path }))
        })
      } else {
        this.navigationMenus.push({
          label: pageData.metaInfo.title,
          path: pageData.path,
          isInner: true,
          openInNewWindow: false
        })
        this.switchRenderPage(pageData)
        this.$nextTick(() => {
          this.$eventBus.$emit('setSelectMenuItem', this.navigationMenus.length - 1)
        })
      }
    },
    switchRenderPage (pageData) {
      this.setCurrentPage(pageData)
      this.changeRoutePath()
      this.$nextTick(() => {
        this.$eventBus.$emit('setSelectMenuItem', _.findIndex(this.navigationMenus, { path: pageData.path }))
      })
    },
    moduleNeedDisabled (item) {
      if (!this.currentPageRenderData?.children) {
        return false
      }
      const videoNavigation = _.find(this.currentPageRenderData.children, item => item.tag === 'VideoNavigation')
      if (item.tag === 'VideoNavigation' && videoNavigation) {
        return true
      }
      return false
    },
    openCreateModuleEditor (item) {
      // VideoNavigation 不允许重复创建
      if (item.tag === 'VideoNavigation' && this.currentPageRenderData?.children && _.find(this.currentPageRenderData.children, item => item.tag === 'VideoNavigation')) {
        return
      }
      const tag = item.tag
      const renderData = createRenderData(tag, this.currentPageRenderData.children.length, this.currentPageRenderData)
      if (item.staticProps) {
        _.merge(renderData.data.props, item.staticProps)
      }
      this.moduleEditor.title = getEditorTitle(renderData, true)
      this.moduleEditor.tag = tag
      this.moduleEditor.props.renderData = renderData
      this.moduleEditor.props.isEditMode = false
      this.moduleEditor.isOpen = true
    },
    openModuleEditor (tag, renderData, isEditMode) {
      this.moduleEditor.title = getEditorTitle(renderData, false)
      this.moduleEditor.tag = tag
      this.moduleEditor.props.renderData = renderData
      this.moduleEditor.props.isEditMode = isEditMode
      this.moduleEditor.isOpen = true
    },
    openModuleChildEditor (renderData, editorName, childRenderData) {
      let isEditMode = true
      if (!childRenderData) {
        isEditMode = false
        childRenderData = createChildRenderData(renderData)
      }
      this.moduleEditor.title = getEditorTitle(childRenderData, !isEditMode)
      this.moduleEditor.tag = editorName
      this.moduleEditor.props.renderData = childRenderData
      this.moduleEditor.props.isEditMode = isEditMode
      this.moduleEditor.isOpen = true
    },
    onModuleEditorClosed () {
      this.moduleEditor.title = null
      this.moduleEditor.tag = null
      this.moduleEditor.props.renderData = null
      this.moduleEditor.props.childRenderData = null
    },
    async onModuleEditorConfirmBtnClick () {
      const result = await this.$refs.editor.validateAndUpdateRenderData()
      if (!result) {
        return
      }
      this.moduleEditor.isOpen = false

      // JobList component can only be added once
      this.toolbarItems.map(item => {
        if (item.tag === this.moduleEditor.tag && item.tag === 'JobList') {
          item.isShow = false
        }
      })
    },
    onModuleEditorDelBtnClick () {
      if (!this.moduleEditor.props.isEditMode) {
        return
      }
      const renderData = this.moduleEditor.props.renderData
      const parentRenderData = renderData.parent
      parentRenderData.children.splice(renderData.index, 1)
      _.forEach(parentRenderData.children, (item, index) => {
        item.index = index
      })
      this.moduleEditor.isOpen = false

      // Show JobList component when it's deleted
      this.toolbarItems.map(item => {
        if (item.tag === this.moduleEditor.tag && item.tag === 'JobList') {
          item.isShow = true
        }
      })
    },
    handlePreviewToggle () {
      if (this.isPreview) {
        this.setPreview(false)
      } else {
        this.setPreview(true)
      }
      this.previewer.class['edit-mode'] = !this.isPreview
    },
    async handleLanguageToggle () {
      const currentLang = this.$i18n.locale
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
      await this.changeLanguage(currentLang === 'en' ? 'en' : 'zh-cn')
    },
    handleConfitEditorOpen () {
      const obj = this.currentPageRenderData.toObject()
      this.configEditor.configCode = JSON.stringify(obj)
      this.configEditor.isOpen = true
    },
    onConfigEditorOkBtnclick () {
      const code = this.configEditor.configCode
      const result = JSON.parse(code)
      this.currentPage.renderData = RenderData.parseObject(result)
      this.configEditor.isOpen = false
    },
    async handleSave () {
      this.resetProjectItemIndex()
      const pages = []
      this.$eventBus.$emit('showLoading', true)
      try {
        _.forEach(this.sitePages, item => {
          pages.push(item.toObject())
        })
        const resp = await this.updateSiteData({
          siteData: {
            id: this.siteId,
            theme: this.theme,
            pages: this.getPagesWithoutFold(pages)
          },
          type: this.siteEditorType
        })
        if (resp) {
          this.$message({ message: this.$t('microSite.common.message.saveSuccess'), type: 'info' })
          this.savedTheme = this.theme
          this.savedSitePages = this.sitePages
        } else {
          this.$message({ message: this.$t('microSite.common.message.failedSave'), type: 'error' })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleBackBtnClick () {
      this.$router.go(-1)
    },
    changeRoutePath () {
      const currentPagePath = this.currentPage.path
      const targetPath = `${this.pagePathPrefix}${currentPagePath}`
      if (this.$route.path !== targetPath) {
        this.$router.push(targetPath)
      }
    },
    togglePage (pageIndex, itemIndex) {
      if (_.isNumber(itemIndex) && itemIndex >= 0) {
        this.sitePages[pageIndex].renderData.children[itemIndex].isFold = !this.sitePages[pageIndex].renderData.children[itemIndex].isFold
      } else {
        this.sitePages[pageIndex].isFold = !this.sitePages[pageIndex].isFold
      }
    },
    toggleProjectItem (pageIndex, itemIndex) {
      const pageData = this.sitePages[pageIndex]
      const moduleItem = pageData.renderData.children[itemIndex]
      moduleItem.skipMatch = !moduleItem.skipMatch
      if (moduleItem.skipMatch) {
        this.navigationMenus = _.filter(this.navigationMenus, item => {
          if (item.path.includes(pageData.path) && item.path.includes(`scrollin=${moduleItem.id}`)) {
            return false
          }
          return true
        })
      }
    },
    getPagesWithoutFold (pages) {
      const pagesCopy = _.cloneDeep(pages)
      _.forEach(pagesCopy, page => delete page.isFold)
      this.getPagesWithoutUselessParams(pagesCopy)
      return pagesCopy
    },
    onPromotionLinkClick (linkItem) {
      const origin = location.origin
      let link = ''
      const linkType = linkItem.linkType
      const companyId = this.companyInfo.id
      switch (linkType) {
        case promotionLinkType.company:
          link = `/company-detail-new/${companyId}/`
          break
        case promotionLinkType.mobileJobList:
          link = `/mobile-web-more-jobs/${companyId}/`
          break
        case promotionLinkType.addInTalentPool:
          link = `/recruiting/company/${companyId}/survey/`
          break
      }
      prompt(this.$t('microSite.editor.promotionLink.copyLink'), `${origin}${link}`)
    },
    getPagesWithoutUselessParams (pages) {
      if (!pages || pages.length < 1) {
        return
      }
      _.forEach(pages, (item) => {
        if (item?.data?.props?.needChildren) {
          delete item.data.props.children
        }
        if (item?.renderData) {
          this.getPagesWithoutUselessParams([item.renderData])
        }
        if (item?.children && item.children.length > 0) {
          this.getPagesWithoutUselessParams(item.children)
        }
      })
    },
    changeChildrenOrder (newIndex, oldIndex, renderData) {
      if (renderData.children?.length < 2) {
        return
      }
      const data = renderData.children.splice(oldIndex, 1)[0]
      renderData.children.splice(newIndex, 0, data)
    }
  },
  watch: {
    pagePath () {
      let pagePath = this.pagePath
      if (!pagePath.startsWith('/')) {
        pagePath = '/' + pagePath
      }
      const pageData = _.find(this.sitePages, { path: pagePath })
      if (pageData) {
        this.switchRenderPage(pageData)
      }
    },
    theme: {
      handler (val, oldVal) {
        const themes = this.themes
        themes[this.siteId] = val
        this.setThemes(themes)
        this.cssStyleList = [
          {
            vmid: this.siteId,
            innerHTML: createRootCssStyle(this.theme.bgColor, this.theme.btnColor)
          }
        ]
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>

.manage-microsite-page {
  height: 100vh;

   ::v-deep * {
     box-sizing: border-box;

     .quill-editor {
       color: black;
       word-break: break-word;
     }
   }

  .el-container {
    height: 100%;
  }

  .header-container {
    display: flex;
    padding: 0;
    background: #3e3f40;
    color: #fff;

    .header-back-btn {
      display: flex;
      width: 250px;
      background: #3e3f40;
      cursor: pointer;

      .btn-icon {
        margin: auto;
        margin-right: 5px;
        margin-left: 20px;
        font-size: 28px;
        font-weight: 600;
      }

      .btn-label {
        margin: auto;
        margin-left: 5px;
        font-size: 18px;
        user-select: none;
      }
    }

    .header-container {
      flex: 1;

      .header-title {
        line-height: 52px;
        padding-left: 10px;
        word-break: keep-all;
        white-space: nowrap;
      }

      .header-save-btn {
        margin-left: auto;
        margin-right: 0;
        width:  135px;
        padding: 10px 20px;

        .el-button {
          width: 100%;
          padding: 8px 20px;
          background: #39b8ce;
          border-color: #39b8ce;;
          color: #fff;
          font-weight: bold;
        }
      }

      .previewer-size {
        margin-left: auto;
        margin-right: 10px;
        padding-top: 5px;

        form {
          padding: 0 !important;

          .el-form-item {
            margin-bottom: 0;
          }

          ::v-deep .el-form-item__label {
            color: #fff;
          }
        }
      }
      .style-toggle {
        margin-left: auto;
        margin-right: 0;
        width:  135px;
        padding: 10px 20px;

        .el-button {
          width: 100%;
          padding: 8px 10px;
          background: #FFF;
          border-color: #FFF;;
          color: #333;
          font-weight: bold;
          // box-shadow: 0 2px 12px 0 #fff;
        }
      }
    }
  }

  .tool-bar-container {
    width: 250px;
    height: calc(100vh - 52px);
    background: #FFF;
    color: #62b3e3;
    box-sizing: border-box;
    border-right: #dee0e1 2px solid;
    position: relative;
    z-index: 100;

    .tool-bar {
      position: relative;

      .tool-bar-size-watcher {
        width: 100%;
        height: 100%;
        position: absolute;
        visibility: hidden;
        margin: 0;
        padding: 0;
        border: 0;
      }

      .tool-item-container {
        border: 0;

        ::v-deep .el-submenu__title:hover{
          background-color: rgba(14, 221, 240, 0.32) !important;
        }
        .el-submenu {
          ::v-deep .el-submenu__icon-arrow {
            color:#62b3e3;
          }
          .submenu-title {
            user-select: none;
          }

          .el-menu-item {
            height: auto;
            padding: 0 !important;

            &.promotion-link-item {
              padding: 0 15px 0 30px !important;
            }
          }
        }

        .el-menu-item {
          i {
            color: #62b3e3;
            margin: 0;
          }
        }

        [class$=-tool-container] {
          background: #FFF;
          padding: 0 15px;
          cursor: default;

          & > [class*=-tool-item] {
            background: #00a1d8;
            font-size: 14px;
          }
        }

        .component-tool-container {
          &::before {
            content: '';
            clear: both;
          }

          &::after {
            content: '';
            display: table;
            clear: both;
          }

          .component-tool-item {
            float: left;
            margin: 5px;
            width: 98px;
            height: 98px;
            padding: 10px;
            text-align: center;
            cursor: pointer;

            .component-tool-item-icon {
              width: 65px;
              height: 65px;
              margin: auto;

              div {
                width: 100%;
                height: 100%;
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                &.iconfont.iconweiwangzhan {
                  color: #fff;
                  font-size: 60px;
                  line-height: 1;
                }
                &.iconfont.iconvideo-library {
                  color: #fff;
                  font-size: 60px;
                  line-height: 1;
                }
              }
            }

            .component-tool-item-label {
              height: 15px;
              line-height: 15px;
              font-size: 14px;
              color: #FFF;
              max-width: 78px;
            }
          }
          .disabled-tool-item {
            cursor: not-allowed;
          }
        }

        .page-menu {
          span {
            display: inline-block;
            height: 19px;
            line-height: 19px;
            vertical-align: middle;
          }

          i {
            margin-left: 10px;
            color: #00a1d8;
          }
        }

        .page-item {
          .page-item-container.el-menu-item {
            width: 90%;
            margin: 0 auto;
            padding: 0 20px !important;
            cursor: pointer;

            div {
              display: inline-block;
            }

            .page-icon {
              i {
                font-size: 16px;
              }
            }

            .page-name {
              margin-left: 10px;
              font-size: 14px;
              user-select: none;
            }

            .page-edit {
              margin-left: auto;
              margin-right: 0px;
              position: absolute;
              right: 30px;
              i {
                cursor: pointer;
                font-size: 16px;
              }
            }

            .page-select {
              position: absolute;
              right: 10px;
              i {
                cursor: pointer;
              }
            }
          }
          .page-divider {
            position: relative;
            margin: -1px auto;
            width: 80% !important;
            height: 1px !important;
            background-color: #cccccc !important;
          }

          .project-item-div {
            width: 90%;
            height: 38px;
            margin: 0 auto;
            padding: 10px 15px 10px 20px;
            i {
              font-size: 16px;
            }
            span {
              user-select: none;
            }

            .project-title {
              overflow:hidden;
              display: inline-block;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: keep-all;
              width: 140px;
              font-size: 14px;
            }

            .hide-project-icon {
              position: absolute;
              right: 34px;
              i {
                cursor: pointer;
              }
            }
            .edit-project-icon {
              position: absolute;
              right: 14px;
              i {
                cursor: pointer;
              }
            }
            .arrow-down-project-icon{
              position: absolute;
              right: 54px;
              i {
                cursor: pointer;
              }
            }
          }
          .subassembly {
            padding-left: 40px;
          }
        }

        .theme-tool-container {
          .theme-tool-item {
            background: #fff;
            padding-left: 15px;
            height: 50px;
            display: flex;

            .theme-tool-item-label {
              margin-right: auto;
              margin-left: 0;
              font-size: 14px;
            }

            .theme-tool-item-color-text {
              margin-left: 5px;
              margin-right: 10px;
              font-size: 14px;
              display: inline-block;
              width: 100px;
              cursor: pointer;
            }

            .theme-tool-item-color-picker {
              margin-left: 30px;
              margin-right: 5px;
              &::v-deep {
                .el-color-picker__trigger {
                  border: 0;
                  padding: 0;
                  border-radius: 0;
                  height: 25px;
                  margin-top: 12px;
                  border: 1px solid rgba(0,0,0,0.1);
                  box-shadow: 0px 0px 0px 2px #f4f4f5;

                  .el-color-picker__color {
                    border-radius: 0;
                    border: 0;
                  }

                  .el-color-picker__icon {
                    visibility: hidden;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .page-previewer-container {
    padding: 0;

    .page-size-container {
      height: 30px;
    }

    .page-previewer {
      height: calc(100vh - 52px);
      overflow: auto;
      display: flex;
      background: rgba($color: #000000, $alpha: 0.6);
      ::v-deep {
        .site-pc {
          .microsite-root {
            height: auto;
            overflow: unset;
          }
        }
      }
    }

    .page-previewer-out-box {
      margin: auto;
      /* need reset all style which can inherit from parent element */
      background: #fff;

      .site-mobile {
        ::v-deep {
          #btnDialogToggle {
            right: unset;
            margin-left: 250px;
          }
        }
      }

        .page-previewer-inner-box {
          position: relative;
        }
    }
  }

  .icon-full-text {
    background-image: url(~@/assets/image/microSite/fullText.png);
  }

  .icon-image-big {
    background-image: url(~@/assets/image/microSite/imageBig.png);
  }

  .icon-image-left {
    background-image: url(~@/assets/image/microSite/imageLeft.png);
  }

  .icon-image-right {
    background-image: url(~@/assets/image/microSite/imageLeft.png);
  }

  .icon-image-top {
    background-size: 85px !important;
    background-image: url(~@/assets/image/microSite/imageTop.png);
  }

  .icon-image-crossed {
    background-image: url(~@/assets/image/microSite/imageCrossed.png);
  }

  .icon-photo-wall {
    background-image: url(~@/assets/image/microSite/photoWall.png);
  }

  .icon-brand-wall {
    background-image: url(~@/assets/image/microSite/brandWall.png);
  }

  .icon-logo-wall {
    background-image: url(~@/assets/image/microSite/logoWall.png);
  }

  .icon-carousel {
    background-image: url(~@/assets/image/microSite/carousel.png);
  }

  .icon-job-list {
    background-image: url(~@/assets/image/microSite/jobList.png);
  }

  .icon-form {
    background-image: url(~@/assets/image/microSite/form.png);
  }

  .code-editor {
    height: 300px;

    .el-textarea {
      height: 100%;
      ::v-deep textarea {
        height: 100%;
      }
    }
  }

  .dialog-footer {
    .delete-btn {
      margin-left: 35px;
      float: left;
    }
  }

  .module-editor {
    ::v-deep .el-dialog {
      min-width: 50%;
      max-width: 90%;
      width: max-content;
    }
  }
}
</style>

<style lang="scss">
.theme-tool-item-color-picker-popper {
  .el-color-dropdown__btns {
    .el-button:nth-child(2) {
      display: none;
    }
  }
}
</style>
